import React, { useState, useEffect } from 'react';
import './home.css';
import { Link } from "react-router-dom";
import emailjs from 'emailjs-com';



import { 
  FaLeaf, 
  FaBolt, 
  FaMoneyCheckAlt, 
  FaShieldAlt, 
  FaGlobeAsia, 
  FaUserCheck 
} from "react-icons/fa";


import { FaPlaneDeparture, FaCity, FaBriefcase, FaHeart } from "react-icons/fa";

function Home() {
  const [activeFeature, setActiveFeature] = useState(0);
  const [bookingForm, setBookingForm] = useState({
    pickup: '',
    destination: '',
    date: '',
    time: '',
    service: 'standard'
  });

//vehicle type  


    const vehicleTypes = [
    { id: 'sedan', name: 'Sedan', capacity: 'Up to 4 passengers' },
    { id: 'suv', name: 'SUV', capacity: 'Up to 6 passengers' },
    { id: 'luxury', name: 'Luxury Car', capacity: 'Up to 4 passengers' },
    { id: 'van', name: 'Van', capacity: 'Up to 8 passengers' }
  ];




 const features = [

  {
    icon: <FaBolt />, // Speed & digital efficiency
    title: "Instant Smart Booking",
    description: "Reserve your ride seamlessly with real-time confirmations and zero delays."
  },
  {
    icon: <FaMoneyCheckAlt />, // Trust and transparency
    title: "Honest & Transparent Pricing",
    description: "No surprises. No hidden charges. Pay only what’s shown — guaranteed."
  },
  {
    icon: <FaShieldAlt />, // Safety & trust
    title: "Safety First Approach",
    description: "Certified drivers, tracked rides, and top-grade vehicle safety standards for every journey."
  },
  {
    icon: <FaGlobeAsia />, // Expansion & reliability
    title: "City-Wide Service Network",
    description: "Wherever you’re headed — airports, hotels, corporate or leisure — we’ve got you covered."
  },

];





  

const testimonials = [
  {
    name: "Anna | UK",
    comment: "Airport pickup was super fast and the vehicle was spotless. Perfect start for my Sri Lanka holiday!",
    rating: 5
  },
  {
    name: "Yuki | Japan",
    comment: "Driver gave great suggestions for places to visit. It felt like a private guided tour!",
    rating: 5
  },
  {
    name: "Marco | Italy",
    comment: "Smooth ride along the coast and amazing scenic stops. Highly recommended!",
    rating: 4
  },
  {
    name: "Aarav | India",
    comment: "Quick booking and great hospitality. Helped us with bags and shared local tips!",
    rating: 5
  },
  {
    name: "Lina | Germany",
    comment: "Great for day trips! Super comfortable car and professional driver.",
    rating: 5
  },
  {
    name: "Nina | France",
    comment: "Luxury feel and eco-friendly! Loved every moment of the ride.",
    rating: 5
  },
  {
    name: "Chen | China",
    comment: "They tracked my flight delay and still greeted me with a smile. Fantastic service!",
    rating: 5
  },
  {
    name: "David | Australia",
    comment: "Easy to communicate and always on time. The safest travel choice here for sure.",
    rating: 4
  },
  {
    name: "Priya | Singapore",
    comment: "Super comfortable for long trips with family. My kids enjoyed a smooth ride!",
    rating: 5
  },
  {
    name: "Ahmed | UAE",
    comment: "Top-class vehicles and classy drivers. Worth the money every time.",
    rating: 5
  },
  {
    name: "Maria | Spain",
    comment: "Sightseeing was so fun with our driver — took beautiful photos for us too!",
    rating: 5
  },
  {
    name: "Tharindu | Sri Lanka",
    comment: "Reliable for every airport run — never late, always friendly!",
    rating: 5
  }
];



const services = [
  {
    img: "/airport-drop.jpg", // put this image in the public folder
    title: "Airport Transfers",
    description: "Reliable and safe airport pick and drop",
    price: "Instant Quote"
  },
  {
    img: "/city-ride.webp",
    title: "City Tours",
    description: "Discover top attractions with comfortable guided rides",
    price: "Instant Quote"
  },
  {
    img: "/corporate-tour.jpg",
    title: "Corporate Travel",
    description: "Premium chauffeured rides tailored to business needs",
    price: "Custom Quote"
  },
  {
    img: "/wedding-service.jpeg",
    title: "Wedding / Events",
    description: "Elegant transportation for your special day",
    price: "Special Packages"
  }
];



  const handleInputChange = (e) => {
    setBookingForm({
      ...bookingForm,
      [e.target.name]: e.target.value
    });
  };





const [current, setCurrent] = useState(0);

// Auto-slide every 4 seconds
useEffect(() => {
  const timer = setInterval(() => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  }, 4000);

  return () => clearInterval(timer); // cleanup
}, [testimonials.length]);

// Button Controls
const nextTestimonial = () => {
  setCurrent((prev) => (prev + 1) % testimonials.length);
};

const prevTestimonial = () => {
  setCurrent((prev) =>
    prev === 0 ? testimonials.length - 1 : prev - 1
  );
};











const handleBookNow = async (e) => {
  e.preventDefault();

  // Find selected vehicle object
  const selectedVehicle = vehicleTypes.find(
    (v) => v.id === bookingForm.vehicleType
  );

  // Prepare same template structure as booking page
  const templateParams = {
    vehicle_type: selectedVehicle ? selectedVehicle.name : '',
    pickup_location: bookingForm.pickup,
    destination: bookingForm.destination,
    date: bookingForm.date,
    time: bookingForm.time,
    passengers: bookingForm.passengers || "Not specified",
    customer_name: bookingForm.customerName || "Quick Booking Customer",
    customer_email: bookingForm.email,
    customer_phone: bookingForm.contactNo,
    special_requests: bookingForm.specialRequests || "None",
    to_email: "info@ecorichtravels.com",
    booking_time: new Date().toLocaleString(),
  };

  try {
    const response = await emailjs.send(
        'service_hyvom0x',
        'template_0m2cp7r',
        templateParams,
        'lM41GBFi-wpxugewO'
    );

    if (response.status === 200) {
      alert("Booking request sent successfully! We will contact you soon.");
    }
  } catch (error) {
    console.error("EmailJS Error:", error);
    alert("Something went wrong while sending your booking request.");
  }

  // Reset form
  setBookingForm({
    pickup: "",
    destination: "",
    date: "",
    time: "",
    contactNo: "",
    email: "",
    vehicleType: "",
    passengers: "",
    customerName: "",
    specialRequests: "",
  });
};





















  return (
    <div className="eco-home-page">
{/* Hero Section */}
{/* Hero Section */}
<section className="eco-hero-section">
  <div className="eco-hero-background">
    {/* Rotating Background Banner */}
    <div className="eco-hero-carousel">
      <div className="eco-carousel-slide eco-active" style={{backgroundImage: "url('/explore srilanka.png')"}}></div>
      <div className="eco-carousel-slide" style={{backgroundImage: "url('/banner2.jpg')"}}></div>
      <div className="eco-carousel-slide" style={{backgroundImage: "url('/explore srilanka.png')"}}></div>
    </div>
    <div className="eco-hero-overlay"></div>




    
   {/* Small Promotional Banners */}
<div className="eco-banner-container">
  <div className="eco-banner-slide eco-active">
    <div className="eco-banner-content">
      <span className="eco-banner-badge"> Pamunugama Special</span>
      <h3>Local Eco Rides</h3>
      <p>Zero emission travel in Pamunugama area</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge"> Colombo Express</span>
      <h3>Pamunugama to Colombo</h3>
      <p>Fixed rates from LKR 3,000</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge"> Airport Transfer</span>
      <h3>BIA from Pamunugama</h3>
      <p>Comfortable rides to Bandaranayake Airport</p>
    </div>
  </div>

  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge"> 24/7 Service</span>
      <h3>All Day Availability</h3>
      <p>Round-the-clock in Pamunugama</p>
    </div>
  </div>

  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Tourist Friendly</span>
      <h3>Explore Sri Lanka</h3>
      <p>Multi-language drivers available</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Expressway Ready</span>
      <h3>Southern & Outer Circular</h3>
      <p>Comfortable highway travel</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Hill Country</span>
      <h3>Kandy & Nuwara Eliya</h3>
      <p>Scenic routes from Pamunugama</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Coastal Tours</span>
      <h3>West & South Coasts</h3>
      <p>Beach destinations made easy</p>
    </div>
  </div>

  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Family Travel</span>
      <h3>Child Seats Available</h3>
      <p>Safe family trips across Sri Lanka</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Local Experts</span>
      <h3>Sri Lankan Drivers</h3>
      <p>Knowledge of all local routes</p>
    </div>
  </div>

  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Fully Insured</span>
      <h3>Comprehensive Cover</h3>
      <p>For all journeys in Sri Lanka</p>
    </div>
  </div>

  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Monsoon Ready</span>
      <h3>All Weather Service</h3>
      <p>Reliable during rainy season</p>
    </div>
  </div>
  <div className="eco-banner-slide">
    <div className="eco-banner-content">
      <span className="eco-banner-badge">Festival Special</span>
      <h3>Avurudu Travel</h3>
      <p>Book early for Sinhala New Year</p>
    </div>
  </div>
</div>
</div>





<div className="eco-container">
  <div className="eco-hero-content">
    <div className="eco-hero-text">
      <h1 className="eco-hero-title">
        <span className="eco-highlight-up"> ECO </span>
        RICH TRAVELS
      </h1>
      <p className="eco-hero-subtitle">
        Experience premium and trustworthy transportation with zero compromise on comfort and reliability. 
        Join the movement towards safe travel across Sri Lanka.
      </p>
      <div className="eco-hero-stats">
        <div className="eco-hero-stat">
          <span className="eco-stat-number">25+</span>
          <span className="eco-stat-label">Districts Covered</span>
        </div>
        <div className="eco-hero-stat">
          <span className="eco-stat-number">40+</span>
          <span className="eco-stat-label">Vehicles</span>
        </div>
        <div className="eco-hero-stat">
          <span className="eco-stat-number">24/7</span>
          <span className="eco-stat-label">Islandwide</span>
        </div>
      </div>
    </div>



      
      {/* Booking Form */}
      <div className="eco-booking-card">
        <h3 className="eco-booking-title">Quick Booking</h3>
        <form className="eco-booking-form" onSubmit={handleBookNow}>
          <div className="eco-form-group">
            <label htmlFor="pickup">Pickup Location</label>
            <input
              type="text"
              id="pickup"
              name="pickup"
              value={bookingForm.pickup}
              onChange={handleInputChange}
              placeholder="Enter pickup address"
              required
            />
          </div>
          <div className="eco-form-group">
            <label htmlFor="destination">Destination</label>
            <input
              type="text"
              id="destination"
              name="destination"
              value={bookingForm.destination}
              onChange={handleInputChange}
              placeholder="Enter destination"
              required
            />
          </div>

          <div className="eco-form-row">
            <div className="eco-form-group">
              <label htmlFor="date">Date</label>
              <input
                type="date"
                id="date"
                name="date"
                value={bookingForm.date}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="eco-form-group">
              <label htmlFor="time">Time</label>
              <input
                type="time"
                id="time"
                name="time"
                value={bookingForm.time}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>


          <div className="eco-form-row">
            <div className="eco-form-group">
              <label htmlFor="Contact No.">Contact No.</label>
              <input
                type="text"
                id="contactNo"
                name="contactNo"
                value={bookingForm.contactNo}
                onChange={handleInputChange}
                placeholder='Enter Your Contact No.'
                required
              />
            </div>
            <div className="eco-form-group">
              <label htmlFor="time">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={bookingForm.email}
                onChange={handleInputChange}
                placeholder="Enter Your Email"
                required
              />
            </div>
          </div>

            <div className="eco-form-group">
              <label htmlFor="vehicleType">Vehicle Type</label>
              <select
                id="vehicleType"
                name="vehicleType"
                value={bookingForm.vehicleType}
                onChange={handleInputChange}
              >
                <option value="">Select a vehicle</option>
                {vehicleTypes.map((vehicle) => (
                  <option key={vehicle.id} value={vehicle.id}>
                    {vehicle.name} — {vehicle.capacity}
                  </option>
                ))}
              </select>
            </div>

            <input
              type="hidden"
              name="customerName"
              value={bookingForm.customerName || "Quick Booking User"}
            />


          <button type="submit" className="eco-book-btn">
            Book Now 
          </button>
        </form>
      </div>


    </div>
  </div>
</section>

{/****************************************************** Who we are  ***********************************************************/}

<section className='who-we-are-container'>
  <div className='who-we-are'>
<div className='who-we-are-content'>
  <h1>ABOUT ECO RICH TRAVEL</h1>
  <p>Established in 2021 and headquartered in Pamunugama, ECO RICH TRAVEL has quickly become a trusted name in reliable and safe transportation. We are dedicated to delivering seamless travel experiences for individuals and groups alike.</p>
  <p>Our professional team emphasizes comfort, punctuality, and exceptional customer service, ensuring that every journey is smooth, stress-free, and enjoyable. We go the extra mile to make each ride memorable.</p>
  <p>From airport transfers and city commutes to sightseeing tours and customized travel plans, ECO RICH TRAVEL offers a versatile fleet of vehicles to meet all transportation needs. We prioritize convenience, safety, and affordability in every service we provide.</p>
</div>

    <div className='who-we-are-image'>
      <img src="/who-we-are-logo.png" alt="Who We Are" />
    </div>
  </div>
</section>





















{/****************************************************** Why Chooose Us ***********************************************************/}


{/* Premium Features Section */}
<section className="eco-features-section">
  <div className="eco-container">
    <div className="eco-left">
      <div className="eco-section-header">
        <h2>Experience the Eco Rich Difference</h2>
        <p>Where sustainable transportation meets uncompromising luxury and reliability</p>
      </div>

      <div className="eco-features-grid">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`eco-feature-card ${activeFeature === index ? 'eco-active' : ''}`}
            onMouseEnter={() => setActiveFeature(index)}
          >
            <div className="eco-feature-icon">{feature.icon}</div>
            <h3 className="eco-feature-title">{feature.title}</h3>
            <p className="eco-feature-desc">{feature.description}</p>
            <div className="eco-card-glow"></div>
          </div>
        ))}
      </div>
    </div>

    {/* Right Side Image */}
    <div className="eco-right-image">
      <img src="/eco rich travel.png" alt="Eco Rich Luxury Car" />
    </div>
  </div>
</section>





{/* <div className="eco-middle-banner">
  <img src="/banner-desktop-1.png" alt="Mid Banner" className="eco-middle-banner-img" />
</div> */}






{/*****************************************************************************************************************/}
{/* Services Preview */}
<section className="eco-service-section">
  <div className="eco-service-container">
    <div className="eco-service-header">
      <h2>Our Services</h2>
    </div>

    <div className="eco-service-grid">
      {services.map((service, index) => (

      
        <div key={index} className="eco-service-card">
          <div className="eco-service-card-image">
            <img src={service.img} alt={service.title} />
          </div>
         
          <h3 className="eco-service-card-title">{service.title}</h3>
          <p className="eco-service-card-desc">{service.description}</p>

        <Link to="/bookings">
          <span className="eco-service-card-price">{service.price}</span>
          </Link>
        </div>

      ))}
    </div>
  </div>
</section>







      {/* App Download CTA */}
      <section className="eco-app-cta">
        <div className="eco-container">
          <div className="eco-app-content">
            <div className="eco-app-text">
              <h2>We ease up your convenience from Airport to the Hoetel on a Call</h2>
              <p>Experience seamless travel with our on-call service, ensuring a smooth and stress-free journey from the airport to your hotel. Just one call connects you to comfort, reliability, and peace of mind.</p>

       
            </div>
            <div className="eco-app-visual">
              <div className="eco-phone-mockup">
                <div className="eco-phone-screen">
                  <div className="eco-app-interface">
                    <div className="eco-app-header">Eco Rich Travels</div>
                    <div className="eco-app-booking">
                      <div className="eco-app-input">Current Location</div>
                      <div className="eco-app-input">Destination</div>
                      <button className="eco-app-book-btn">Book Eco Ride</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


 {/* Testimonials */}
<section className="eco-testimonials-section">
  <div className="eco-container">
    <div className="eco-section-header">
      <h2>What Our Customers Say</h2>
      <p>Real experiences from travelers around the world</p>
    </div>

    <div className="eco-testimonials-carousel">
      <button className="eco-carousel-btn left" onClick={prevTestimonial}>
        ‹
      </button>

      <div className="eco-testimonial-card">
        <img src='/google.png' />
        <div className="eco-testimonial-rating">
          {"⭐".repeat(testimonials[current].rating)}
        </div>
        <p className="eco-testimonial-text">
          "{testimonials[current].comment}"
        </p>
        <div className="eco-testimonial-author">
          <strong>{testimonials[current].name}</strong>
          <span>{testimonials[current].role}</span>
        </div>
      </div>

      <button className="eco-carousel-btn right" onClick={nextTestimonial}>
        ›
      </button>
    </div>
  </div>
</section>



      {/* Final CTA */}
{/* Final CTA */}
<section className="eco-cta-section">
  <div className="eco-cta-container">
    <div className="eco-cta-box">
      <h2 className="eco-cta-title">Ready to Make a Difference?</h2>
      <p className="eco-cta-subtitle">Every ride with us contributes to a cleaner, greener planet</p>
      <div className="eco-cta-buttons-wrapper">

        <Link to="/bookings">
        <button className="eco-cta-button eco-cta-primary">Book Your First Ride</button>
        </Link>

        <a href="tel:+94742947134">
          <button className="eco-cta-button eco-cta-secondary">Call: +94 74 294 7134</button>
        </a>


      </div>
    </div>
  </div>
</section>

    </div>
  );
}

export default Home;